import { render, staticRenderFns } from "./LabsView.vue?vue&type=template&id=5666d4bd&scoped=true&"
import script from "./LabsView.vue?vue&type=script&lang=ts&"
export * from "./LabsView.vue?vue&type=script&lang=ts&"
import style0 from "./LabsView.vue?vue&type=style&index=0&id=5666d4bd&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5666d4bd",
  null
  
)

export default component.exports